import { CheckoutFacialRecognitionProcess } from 'modules/checkout/infra/adapters';
import { makeStorageProvider } from 'shared/infra/providers';

/**
 * Compara pela chave serializada: `key` é um array, e só ela entra na conta porque o
 * repositório de reconhecimento escreve em `process.params` depois de gravar.
 */
export default function hasValidFacialRecognition(params: {
  budgetId: number;
  customerId: number;
}) {
  const process = new CheckoutFacialRecognitionProcess(params);

  const storedProcesses = makeStorageProvider().get(
    'VALID_FACIAL_RECOGNITIONS',
  );

  return !!storedProcesses?.some(
    storedProcess => storedProcess.key?.join('|') === process.key.join('|'),
  );
}
